/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_ComposeInputs */

const en_us2_quick_workout_compose = /** @type {(inputs: Quick_Workout_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build the session`)
};

const pt_br2_quick_workout_compose = /** @type {(inputs: Quick_Workout_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar treino`)
};

const es_419_quick_workout_compose = /** @type {(inputs: Quick_Workout_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armar entrenamiento`)
};

const pt_pt2_quick_workout_compose = /** @type {(inputs: Quick_Workout_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar treino`)
};

const fr_fr2_quick_workout_compose = /** @type {(inputs: Quick_Workout_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer la séance`)
};

const de_de2_quick_workout_compose = /** @type {(inputs: Quick_Workout_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training erstellen`)
};

const it_it2_quick_workout_compose = /** @type {(inputs: Quick_Workout_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea la sessione`)
};

/**
* | output |
* | --- |
* | "Build the session" |
*
* @param {Quick_Workout_ComposeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_compose = /** @type {((inputs?: Quick_Workout_ComposeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_ComposeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_compose(inputs)
	if (locale === "es-419") return es_419_quick_workout_compose(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_compose(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_compose(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_compose(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_compose(inputs)
	return en_us2_quick_workout_compose(inputs)
});
export { quick_workout_compose as "quick-workout.compose" }